// https://support.karte.io/post/ALVPd86B5a3m4Gjj6Q7hq#1-5

export default function karteView() {
  try {
    (window as any).tracker.view();
  } catch (e) {
    console.log("karte.view: ", e);
  }
}
